import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import ShipperSidebar from '../shipper/Sidebar';
import ManageNotifications from '../notifications/manage-notifications';
import SessionStore from '../../../stores/SessionStore';
import Container from '../../v2/container';
const NotificationsPage = () => {
    const [type, setType] = useState(null);
    useEffect(() => {
        setType(SessionStore.getUserType());
    }, []);
    return (React.createElement(Container, null,
        React.createElement("div", { className: "lg:grid lg:grid-cols-12 lg:gap-6 mt-10" },
            React.createElement("div", { className: "lg:col-span-3" },
                type === 'Carrier' && React.createElement(Sidebar, { activePage: "notifications" }),
                type === 'Shipper' && React.createElement(ShipperSidebar, { activePage: "notifications" })),
            React.createElement("div", { className: "lg:col-span-9" },
                React.createElement(ManageNotifications, null)))));
};
export default NotificationsPage;
